'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/support-select.html'),
        transclude: true,
        scope: {
            org: '=myValue',
            mySize: '=?mySize',
            myFilters: '=?myFilters',
            myRequired: '=?myRequired'
        },
        controller: ['$scope', 'OrgService',
            function ($scope, OrgService) {

                $scope.select = select;
                $scope.clear = clear;

                // region Function

                function select() {
                    OrgService.select($scope.org, $scope.myFilters).result.then((data) => $scope.org = data);
                }

                function clear() {
                    $scope.org = null;
                }

                // endregion

            }]
    };
}
